import { LIQUID_ENGINE, PPC_BADGE_TEST, BUY_IT_AGAIN, HIRE_AGAIN } from './constants';

/**
 * Whether or not a gig is considered a "rising talent".
 * @param  {String}  [gigType=''] The gig's type.
 * @return {Boolean}
 */
export const isRisingTalent = (gigType = '') => gigType === LIQUID_ENGINE;

/**
 * Whether or not a gig is in the ppc ad badge test.
 * @param  {String}  [gigType=''] The gig's type.
 * @return {Boolean}
 */
export const inPpcAdBadgeTest = (gigType = '') => gigType === PPC_BADGE_TEST;

/**
 * Whether or not a gig is considered a buy again option.
 * @param  {String}  [gigType=''] The gig's type.
 * @return {Boolean}
 */
export const isBuyItAgain = (gigType = '') => gigType === BUY_IT_AGAIN;

/**
 * Whether or not a gig is considered a hire again option.
 * @param  {String}  [gigType=''] The gig's type.
 * @return {Boolean}
 */
export const isHireAgain = (gigType = '') => gigType === HIRE_AGAIN;



// WEBPACK FOOTER //
// ./src/utils/gigTypes/index.js